// Preserved blueprint: recover the old heartbeat/sensor source before wiring live data.
export default function HeartbeatMonitor() {
  return (
    <div className="bg-gray-900/20 border border-gray-800 rounded-lg p-3">
      <div className="flex items-baseline justify-between mb-2">
        <h3 className="text-xs font-mono text-gray-500 uppercase">Heartbeat</h3>
        <span className="text-[9px] uppercase tracking-wider text-yellow-500/70">Blueprint</span>
      </div>
      <div className="text-[10px] text-gray-600 font-mono space-y-1">
        <p>Heartbeat monitor not yet wired.</p>
        <p>Recover the pre-split sensor contract before declaring liveness.</p>
      </div>
    </div>
  );
}
